import React, { Component } from 'react';
import { Route, Switch, Redirect, withRouter } from 'react-router-dom'
import NProgress from 'nprogress'

import Selector from '../Selector';
import BarChart from '../charts/BarChart';
import PieChart from '../charts/PieChart';
import AsterChart from '../charts/AsterChart';

import Train from '../../services/train.js';
import QueryParamsUtils from '../../services/QueryParamsUtils.js';

import '../../../css/UserCharts.css';

class UserCharts extends Component {

  constructor(props, context) {
    super(props, context);
    this.state = {
    }
  }

  componentDidMount() {
    this.fetchData(this.props.match.params.user);
  }

  componentDidUpdate() {

  }

  componentWillReceiveProps(newProps) {
    this.setState({});
  }

  fetchData(userId) {

    this.scrobblesPromise = Train.fetchUserSummary({user: userId, type: 'scrobbles'})
    .then((data) => {
      this.setState({scrobbles: data.scrobbles});
    });

    this.allArtistsPromise = Train.fetchUserSummary({user: userId, type: 'all_artists'})
    .then((data) => {
      this.setState({allArtists: data.artists});
    });

    this.newArtistsPromise = Train.fetchUserSummary({user: userId, type: 'new_artists'})
    .then((data) => {
      this.setState({newArtists: data.artists});
    });

    this.discoveredArtistsPromise = Train.fetchUserSummary({user: userId, type: 'discovered_artists'})
    .then((data) => {
      this.setState({discoveredArtists: data.artists});
    });

    this.topCountriesPromise = Train.fetchUserSummary({user: userId, type: 'top_countries'})
    .then((data) => {
      this.setState({topCountries: data});
    });

    this.topGendersPromise = Train.fetchUserSummary({user: userId, type: 'top_genders'})
    .then((data) => {
      this.setState({topGenders: data});
    });

    this.topYearsPromise = Train.fetchUserSummary({user: userId, type: 'top_years'})
    .then((data) => {
      this.setState({topYears: data});
    });

    this.topTagsPromise = Train.fetchUserSummary({user: userId, type: 'top_tags'})
    .then((data) => {
      this.setState({topTags: data});
    });

  }

  userId() {
    return this.props.match.params.user;
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (this.props.location.pathname !== nextProps.location.pathname) {
      return true;
    } else if (this.currentChart) {
      return nextState[this.currentChart] !== this.state[this.currentChart];
    } else {
      return true;
    }
  }

  render() {

    let summaryPageCb = (params, d, type) => {

      params.month = d.month;
      params.year = d.year;

      let queryParams = QueryParamsUtils.toQueryParams(params);

      let basePath = `/users/${this.userId()}`;
      let url = `${basePath}/${type}/${queryParams}`;
      this.props.history.push(url);
    };
  
    let pieChartCb = (name, type) => {

      let params = {};
      params[type] = name.toLowerCase();

      let queryParams = QueryParamsUtils.toQueryParams(params);

      let basePath = `/users/${this.userId()}`;
      let url = `${basePath}/artists/${queryParams}`;
      this.props.history.push(url);
    };

    let basePath = `/users/${this.userId()}/charts`;

    let selectorElements = [
      {title: 'Scrobbles', url: `${basePath}/scrobbles`},
      {title: 'All artists', url: `${basePath}/all-artists`},
      {title: 'New artists', url: `${basePath}/new-artists`}, 
      {title: 'Discovered artists', url: `${basePath}/discovered-artists`},
      {title: 'Top countries', url: `${basePath}/top-countries`},
      {title: 'Top vocals', url: `${basePath}/top-genders`},
      {title: 'Top years', url: `${basePath}/top-years`},
      {title: 'Top tags', url: `${basePath}/top-tags`}
    ];

    let progressBarForPromise = (promise) => {
      NProgress.start();
      if (promise) {
        promise.then(() => NProgress.done());
      }
    };

    return (
      <div id="charts">

        <Selector elements={selectorElements}></Selector>

        <Switch>
          <Route path="/users/:user/charts/scrobbles" component={ () => {
            this.currentChart = 'scrobbles';
            progressBarForPromise(this.scrobblesPromise);
            return <BarChart data={this.state.scrobbles} type={'scrobbles'} label={'Scrobbles'} clickCb={summaryPageCb.bind(this, {})}/>
          }}>
          </Route>

          <Route path="/users/:user/charts/all-artists" component={ () => {
            this.currentChart = 'allArtists';
            progressBarForPromise(this.allArtistsPromise);
            return <BarChart data={this.state.allArtists} type={'artists'} label={'All artists'} clickCb={summaryPageCb.bind(this, {})}/>
          }}>
          </Route>

          <Route path="/users/:user/charts/new-artists" component={ () => {
            this.currentChart = 'newArtists';
            progressBarForPromise(this.newArtistsPromise);
            return <BarChart data={this.state.newArtists} type={'artists'} label={'New artists'} clickCb={summaryPageCb.bind(this, {new: true})}/>
          }}> 
          </Route>

          <Route path="/users/:user/charts/discovered-artists" component={ () => {
            this.currentChart = 'discoveredArtists';
            progressBarForPromise(this.discoveredArtistsPromise);
            return <BarChart data={this.state.discoveredArtists} type={'artists'} label={'Discovered artists'} clickCb={summaryPageCb.bind(this, {discovered: true})}/>
          }}>
          </Route>

          <Route path="/users/:user/charts/top-countries" component={ () => {
            this.currentChart = 'topCountries';
            progressBarForPromise(this.topCountriesPromise);
            return <PieChart data={this.state.topCountries} type={'country'} label={'Top countries'} clickCb={pieChartCb}/>
          }}>
          </Route>

          <Route path="/users/:user/charts/top-genders" component={ () => {
            this.currentChart = 'topGenders';
            progressBarForPromise(this.topGendersPromise);
            return <PieChart data={this.state.topGenders} type={'gender'} label={'Top vocals'} clickCb={pieChartCb}/>
          }}>
          </Route>

          <Route path="/users/:user/charts/top-years" component={ () => {
            this.currentChart = 'topYears';
            progressBarForPromise(this.topYearsPromise);
            return <PieChart data={this.state.topYears} type={'timePeriod'} label={'Top years'} clickCb={pieChartCb}/>
          }}>
          </Route>

          <Route path="/users/:user/charts/top-tags" component={ () => { 
            this.currentChart = 'topTags';
            progressBarForPromise(this.topTagsPromise);
            return <AsterChart data={this.state.topTags} type={'tag'} label={'Top tags'} clickCb={pieChartCb}/>
          }}>
          </Route>

          <Route render={ () => <Redirect to={`${basePath}/scrobbles`}/> }></Route>
          
        </Switch>

      </div>
    ); 

  }
}

export default withRouter(UserCharts);



// WEBPACK FOOTER //
// ./src/js/components/user/UserCharts.jsx